/**
 * @module FE-CU45_救急情報設定画面
 */
import Header from '../../components/header/Header.vue';
import ListPanel from '../../components/listPanel/ListPanel.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import BreadCrumbList from '@/components/breadCrumb/List.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../constants';

const PAGE_ID = 'FE-CU45';

export default {
  name: 'FirstAidInfo',
  components: {
    Header,
    ListPanel,
    MobileFooter,
    PcPageTitle,
    BreadCrumbList,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU45救急情報設定画面.救急情報設定'),
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU45救急情報設定画面.C0001'),
      // 対象地区 - 自宅
      panelTitlePlace: {
        place: '',
        type: '$vuetify.FECU45救急情報設定画面.対象地区詳細表示領域.対象地区',
        typeIsBefore: true,
      },
      displayAreaListPlace: [],
      // カメラ - リビングカメラ
      panelTitleCammera: {
        place: '',
        type: '$vuetify.FECU45救急情報設定画面.カメラ詳細表示領域.カメラ',
        typeIsBefore: true,
      },
      displayAreaListCammera: [],
      firstAidInfo: {},
      firstAidInfoList: [
        {
          name: '',
          kanaName: '',
          gender: '',
          birthdate: '',
          pastIllnesses: '',
          medicalInstitutionName: '',
          address: '',
          phoneNumber: '',
          responsibleDoctor: '',
        },
        {
          name: '',
          kanaName: '',
          gender: '',
          birthdate: '',
          pastIllnesses: '',
          medicalInstitutionName: '',
          address: '',
          phoneNumber: '',
          responsibleDoctor: '',
        },
      ],
      personId: 0,
      // 氏名
      name: '',
      nameError: '',
      // 氏名（カナ）
      nameKana: '',
      nameKanaError: '',
      // 性別
      gender: '',
      // 生年月日
      birthdate: '',
      dateMenu: false,
      // 既往歴
      anamnesis: '',
      anamnesisError: '',
      // 医療機関名
      hospitalName: '',
      hospitalNameError: '',
      // 医療機関住所
      hospitalAddress: '',
      hospitalAddressError: '',
      // 医療機関電話番号
      hospitalTel: '',
      hospitalTelError: '',
      // 担当医師
      doctor: '',
      doctorError: '',
      isValid: false,
      dialog: false,
      modified: '',
      index: 0,
    };
  },
  created() {},
  computed: {
    // 氏名
    nameRule() {
      return [
        !!this.firstAidInfo.name ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU45救急情報設定画面.E0001'),
      ];
    },
    // 氏名（カナ）
    nameKanaRule() {
      if (
        this.firstAidInfo.kanaName === '' ||
        this.firstAidInfo.kanaName === null ||
        this.firstAidInfo.kanaName === undefined
      ) {
        return [this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU45救急情報設定画面.E0003')];
      }
      if (!/^[ァ-ヶー　]+$/.test(this.firstAidInfo.kanaName) /* eslint-disable-line */) {
        return [this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU45救急情報設定画面.E0005')];
      }
    },

    // 性別
    genderRule() {
      return [
        !!this.gender ||
          this.gender !== '' ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU45救急情報設定画面.E0006'),
      ];
    },

    // 生年月日
    birthdayRule() {
      if (this.dateShow === '') {
        return [this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU45救急情報設定画面.E0007')];
      }
      if (!/^[0-9-/]+$/.test(this.dateShow)) {
        return [this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU45救急情報設定画面.E0008')];
      }
    },

    // 既往歴
    anamnesisRule() {
      return [
        !!this.firstAidInfo.pastIllnesses ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU45救急情報設定画面.E0011'),
      ];
    },

    // 医療機関名
    hospitalNameRule() {
      return [
        !!this.firstAidInfo.medicalInstitutionName ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU45救急情報設定画面.E0013'),
      ];
    },

    // 医療機関住所
    hospitalAddressRule() {
      return [
        !!this.firstAidInfo.address ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU45救急情報設定画面.E0015'),
      ];
    },

    // 医療機関電話番号
    hospitalTelRule() {
      if (
        this.firstAidInfo.phoneNumber === '' ||
        this.firstAidInfo.phoneNumber === null ||
        this.firstAidInfo.phoneNumber === undefined
      ) {
        return [this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU45救急情報設定画面.E0017')];
      }
      if (!/^[0-9-]+$/.test(this.firstAidInfo.phoneNumber)) {
        return [this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU45救急情報設定画面.E0018')];
      }
    },
    // 担当医師
    doctorRule() {
      return [
        !!this.firstAidInfo.responsibleDoctor ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU45救急情報設定画面.E0020'),
      ];
    },

    dateShow: {
      get() {
        return this.birthdate ? this.formatDisplayDate(this.birthdate) : '';
      },
    },
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU45救急情報設定画面.救急情報設定'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU45救急情報設定画面.C0001'),
      };
    },
    today() {
      return new Date()
        .toLocaleDateString('ja-JP', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
        .split('/')
        .join('-');
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 性別変更時の処理
     */
    updateGender() {
      this.firstAidInfoList[this.index].gender = this.gender;
      this.firstAidInfo.gender = this.gender;
    },
    /**
     * 性別からフォーカスが外れた場合の処理
     */
    execGenderValidation() {
      if (this.gender === '') {
        this.gender = null;
      }
    },
    /**
     * 生年月日フォーマット処理(From"YYYY-MM-DD" To"YYYY/MM/DD")
     * @param {Date} date 生年月日(YYYY-MM-DD)
     * @returns 生年月日(YYYY/MM/DD)
     */
    formatDisplayDate(date) {
      const year = date.substr(0, 4);
      const month = date.substr(5, 2);
      const day = date.substr(8, 2);
      return year + '/' + month + '/' + day;
    },
    /**
     * 生年月日フォーマット処理(From"YYYY/MM/DD" To"YYYY-MM-DD")
     * @param {Date} date 生年月日(YYYY/MM/DD)
     * @returns 生年月日(YYYY-MM-DD)
     */
    formatDate(date) {
      const year = date.substr(0, 4);
      const month = date.substr(5, 2);
      const day = date.substr(8, 2);
      return year + '-' + month + '-' + day;
    },
    /**
     * 救急情報取得(表示地区)API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns apiData レスポンス
     */
    APP_CU4401: async function (param, queries, method) {
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: {
            //       usagePlan: 0,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //     },
            //     firstAidInfoList: [
            //       // 変更の場合
            //       {
            //         name: "山田太郎",
            //         kanaName: "ヤマダタロウ",
            //         gender: 1,
            //         birthdate: "1192-11-11",
            //         pastIllnesses: "高血圧",
            //         medicalInstitutionName: "福岡病院",
            //         address: "福岡県福岡市博多区博多駅中央街1-1",
            //         phoneNumber: "092-111-1111",
            //         responsibleDoctor: "福岡太郎",
            //       },
            //       // {
            //       //   name: "山田花子",
            //       //   kanaName: "ヤマダハナコ",
            //       //   gender: 3,
            //       //   birthdate: "1195-09-01",
            //       //   pastIllnesses: "なし",
            //       //   medicalInstitutionName: "札幌病院",
            //       //   address: "北海道札幌市北区北6条西4丁目",
            //       //   phoneNumber: "011-222-3333",
            //       //   responsibleDoctor: "札幌太郎",
            //       // },
            //       // 新規の場合
            //       {
            //         name: null,
            //         kanaName: null,
            //         gender: null,
            //         birthdate: null,
            //         pastIllnesses: null,
            //         medicalInstitutionName: null,
            //         address: null,
            //         phoneNumber: null,
            //         responsibleDoctor: null,
            //       },
            //       // {
            //       //   name: null,
            //       //   kanaName: null,
            //       //   gender: null,
            //       //   birthdate: null,
            //       //   pastIllnesses: null,
            //       //   medicalInstitutionName: null,
            //       //   address: null,
            //       //   phoneNumber: null,
            //       //   responsibleDoctor: null,
            //       // },
            //     ],
            //     modified: "2022-05-06 09:00:00",
            //   },
            // };

            if (apiData.contentsInfo.displayDistrictInfo.usagePlan === 3) {
              this.$router.replace('/top');
            }
            if (apiData.contentsInfo.firstAidInfoList.length == 0) {
              this.$router.push('/emergencyContact');
              return;
            }

            if (this.personId == 0) {
              // 新規作成
              apiData.contentsInfo.firstAidInfoList.forEach((element) => {
                if (this.isExistFirstAidInfo(element)) {
                  this.index++;
                }
              });
              this.firstAidInfo.birthdate = this.birthdate;
            } else {
              // 変更
              this.index = this.personId - 1;
              this.firstAidInfo = apiData.contentsInfo.firstAidInfoList[this.index];
              this.gender = apiData.contentsInfo.firstAidInfoList[this.index].gender;
              this.birthdate = new Date(this.firstAidInfo.birthdate).toISOString().substring(0, 10);
            }
            this.firstAidInfoList = apiData.contentsInfo.firstAidInfoList;

            // 利用プランの確認
            this.checkUsagePlan(apiData.contentsInfo.displayDistrictInfo.usagePlan);

            this.modified = apiData.contentsInfo.modified;

            const targetItem = apiData.contentsInfo.displayDistrictInfo;

            // ------- データ整形 ---------
            const labels = {
              usagePlan: '$vuetify.FECU45救急情報設定画面.対象地区詳細表示領域.利用プラン',
              customerNumber: '$vuetify.FECU45救急情報設定画面.対象地区詳細表示領域.お客様番号',
              securityDestinationName:
                '$vuetify.FECU45救急情報設定画面.対象地区詳細表示領域.警備先名',
              districtSplitNumber: '$vuetify.FECU45救急情報設定画面.対象地区詳細表示領域.地区番号',
              districtSplitName: '$vuetify.FECU45救急情報設定画面.対象地区詳細表示領域.地区名',
              displayDistrictNickname:
                '$vuetify.FECU45救急情報設定画面.対象地区詳細表示領域.ニックネーム対象地区',
            };
            const targetKeys = [
              'usagePlan',
              'customerNumber',
              'securityDestinationName',
              'districtSplitNumber',
              'districtSplitName',
              'displayDistrictNickname',
            ];
            const planTitles = {
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
            };

            // ListPanelコンポーネント用に整形
            Object.keys(targetItem).map((key) => {
              if (targetKeys.includes(key)) {
                let text = targetItem[key];
                if (key === 'usagePlan') {
                  text = planTitles[targetItem[key]];
                }
                if (key === 'districtSplitNumber') {
                  if (targetItem[key] === '    ') {
                    text = '$vuetify.FECU45救急情報設定画面.メイン地区';
                  }
                  if (targetItem[key] === '') {
                    return;
                  }
                }
                this.displayAreaListPlace = [
                  ...this.displayAreaListPlace,
                  {
                    title: labels[key],
                    text: text,
                    isVuetifyKey: text.includes('$'),
                  },
                ];
              }
            });
            this.panelTitlePlace = {
              place: `- ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname}`,
              type: '$vuetify.FECU45救急情報設定画面.対象地区詳細表示領域.対象地区',
              typeIsBefore: true,
            };
          },
          (error /* eslint-disable-line */) => {
            if (error.message.includes('403')) {
              this.$router.replace('/top');
              return;
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 救急情報取得(カメラ)API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns apiData レスポンス
     */
    APP_CU4402: async function (param, queries, method) {
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     cameraInfo: {
            //       usagePlan: 0,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //       cameraNickName: "リビングカメラ",
            //       deviceID: "1111",
            //     },
            //     firstAidInfoList: [
            //       {
            //         name: "山田太郎",
            //         kanaName: "ヤマダタロウ",
            //         gender: 2,
            //         birthdate: "1192-11-11",
            //         pastIllnesses: "高血圧",
            //         medicalInstitutionName: "福岡病院",
            //         address: "福岡県福岡市博多区博多駅中央街1-1",
            //         phoneNumber: "092-111-1111",
            //         responsibleDoctor: "福岡太郎",
            //       },
            //       // {
            //       //   name: "山田花子",
            //       //   kanaName: "ヤマダハナコ",
            //       //   gender: 3,
            //       //   birthdate: "1195-09-01",
            //       //   pastIllnesses: "なし",
            //       //   medicalInstitutionName: "札幌病院",
            //       //   address: "北海道札幌市北区北6条西4丁目",
            //       //   phoneNumber: "011-222-3333",
            //       //   responsibleDoctor: "札幌太郎",
            //       // },
            //       {
            //         name: null,
            //         kanaName: null,
            //         gender: null,
            //         birthdate: null,
            //         pastIllnesses: null,
            //         medicalInstitutionName: null,
            //         address: null,
            //         phoneNumber: null,
            //         responsibleDoctor: null,
            //       },
            //     ],
            //     modified: "2022-05-06 09:00:00",
            //   },
            // };

            if (apiData.contentsInfo.cameraInfo.usagePlan === 102) {
              this.$router.replace('/top');
            }
            if (apiData.contentsInfo.firstAidInfoList.length == 0) {
              this.$router.push('/emergencyContact');
              return;
            }

            if (this.personId == 0) {
              // 新規作成
              apiData.contentsInfo.firstAidInfoList.forEach((element) => {
                if (this.isExistFirstAidInfo(element)) {
                  this.index++;
                }
              });
            } else {
              // 変更
              this.index = this.personId - 1;
              this.firstAidInfo = apiData.contentsInfo.firstAidInfoList[this.index];
              this.gender = apiData.contentsInfo.firstAidInfoList[this.index].gender;
              this.birthdate = new Date(this.firstAidInfo.birthdate).toISOString().substring(0, 10);
            }
            this.firstAidInfoList = apiData.contentsInfo.firstAidInfoList;

            // 利用プランの確認
            this.checkUsagePlan(
              apiData.contentsInfo.cameraInfo.usagePlan
              // apiData.contentsInfo.firstAidInfoList
            );

            this.modified = apiData.contentsInfo.modified;

            const targetItem = apiData.contentsInfo.cameraInfo;

            // ------- データ整形 ---------

            const labels = {
              usagePlan: '$vuetify.FECU45救急情報設定画面.カメラ詳細表示領域.利用プラン',
              customerNumber: '$vuetify.FECU45救急情報設定画面.カメラ詳細表示領域.お客様番号',
              securityDestinationName:
                '$vuetify.FECU45救急情報設定画面.カメラ詳細表示領域.警備先名',
              districtSplitNumber: '$vuetify.FECU45救急情報設定画面.カメラ詳細表示領域.地区番号',
              districtSplitName: '$vuetify.FECU45救急情報設定画面.カメラ詳細表示領域.地区名',
              displayDistrictNickname:
                '$vuetify.FECU45救急情報設定画面.対象地区詳細表示領域.ニックネーム対象地区',
              deviceID: '$vuetify.FECU45救急情報設定画面.カメラ詳細表示領域.デバイスID',
            };
            const targetKeys = [
              'usagePlan',
              'customerNumber',
              'securityDestinationName',
              'districtSplitNumber',
              'districtSplitName',
              'displayDistrictNickname',
              'deviceID',
            ];
            const planTitles = {
              [CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.カメラ依頼かけつけプラン',
              [CONSTANTS.CAMERA_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.カメラセルフ監視プラン',
            };
            // ListPanelコンポーネント用に整形
            Object.keys(targetItem).map((key, index) => {
              if (targetKeys.includes(key)) {
                let text = targetItem[key];
                if (key === 'usagePlan') {
                  text = planTitles[targetItem[key]];
                }
                if (key === 'districtSplitNumber') {
                  if (targetItem[key] === '    ') {
                    text = '$vuetify.FECU45救急情報設定画面.メイン地区';
                  }
                  if (targetItem[key] === '') {
                    return;
                  }
                }
                this.displayAreaListCammera = [
                  ...this.displayAreaListCammera,
                  {
                    id: index,
                    title: labels[key],
                    text: text,
                    isVuetifyKey: text.includes('$'),
                  },
                ];
              }
            });
            // カメラニックネームを設定
            this.panelTitleCammera = {
              place: `- ${apiData.contentsInfo.cameraInfo.cameraNickName}`,
              type: '$vuetify.FECU45救急情報設定画面.カメラ詳細表示領域.カメラ',
              typeIsBefore: true,
            };
          },
          (error /* eslint-disable-line */) => {
            if (error.message.includes('403')) {
              this.$router.replace('/top');
              return;
            }
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 救急情報更新(表示地区)API実行処理
     */
    APP_CO9908: async function () {
      let param = '/api/common/updateContactInfoForDisplayDistrict';
      // let param = "post";
      let method = 'post';

      this.firstAidInfoList[this.index] = this.firstAidInfo;

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        modified: this.modified,
        firstAidInfo: this.firstAidInfoList,
      };

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(() => {
          this.informationDialog();
        })
        .catch((error) => {
          if (error.message.includes('400')) {
            this.$errorDialog('$vuetify.メッセージ一覧.FECU45救急情報設定画面.E0022', false, true);
          } else if (error.message.includes('409')) {
            this.$errorDialog('$vuetify.メッセージ一覧.FECU45救急情報設定画面.E0028', false, true);
          } else {
            this.$_abnormality(error.response.status);
          }
        })
        .finally(() => {
          this.$_setLoading(false);
        });

      // console.log("APP_CO9908>>>");
    },
    /**
     * 救急情報更新(カメラ)API実行処理
     */
    APP_CO9909: async function () {
      let param = '/api/common/updateContactInfoForCamera';
      // let param = "post";
      let method = 'post';

      this.firstAidInfoList[this.index] = this.firstAidInfo;

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID,
        modified: this.modified,
        firstAidInfo: this.firstAidInfoList,
      };

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(() => {
          this.informationDialog();
        })
        .catch((error) => {
          if (error.message.includes('400')) {
            this.$errorDialog('$vuetify.メッセージ一覧.FECU45救急情報設定画面.E0022', false, true);
          } else if (error.message.includes('409')) {
            this.$errorDialog('$vuetify.メッセージ一覧.FECU45救急情報設定画面.E0028', false, true);
          } else {
            this.$_abnormality(error.response.status);
          }
        })
        .finally(() => {
          this.$_setLoading(false);
        });

      // console.log("APP_CO9909>>>");
    },
    /**
     * 設定完了通知ダイアログ呼び出し処理
     */
    informationDialog: async function () {
      const result = await this.$informationDialog(
        '$vuetify.FECU45救急情報設定画面.設定が完了しました'
      );
      if (result === true) {
        this.$router.push({
          path: '/emergencyContact',
          params: { tabIndex: 3 },
        });
      }
    },
    /**
     * 救急情報のデータ有無チェック処理
     * @param {*} contact 救急情報
     * @returns 救急情報にデータが有るかどうか
     */
    isExistFirstAidInfo(contact) {
      if (
        contact.name === null &&
        contact.kanaName === null &&
        contact.gender === null &&
        contact.birthdate === null &&
        contact.pastIllnesses === null &&
        contact.medicalInstitutionName === null &&
        contact.address === null &&
        contact.phoneNumber === null &&
        contact.responsibleDoctor === null
      ) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 利用プランの確認処理
     * @param {*} usagePlan 利用プラン
     */
    checkUsagePlan: function (usagePlan) {
      if (usagePlan === 3 || usagePlan === 102) {
        this.$router.replace({
          path: '/top',
        });
      }
      // データをマッピング
      // const personId = Number(this.$route.query.id);
      // firstAidInfoList.forEach((element, idx) => {
      //   if (personId === idx + 1) {
      //     this.name = element.name;
      //     this.nameKana = element.kanaName;
      //     this.gender = String(element.gender);
      //     this.birthdate = element.birthdate;
      //     this.anamnesis = element.pastIllnesses;
      //     this.hospitalName = element.medicalInstitutionName;
      //     this.hospitalAddress = element.address;
      //     this.hospitalTel = element.phoneNumber;
      //     this.doctor = element.responsibleDoctor;
      //   }
      // });
    },
    /**
     * 登録確認ダイアログ呼び出し処理
     */
    async callSaveAgreementDialogDialog() {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.agreementDialog.入力された内容で登録します',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );
      if (result === true) {
        this.$_setLoading(true);
        // 遷移元の画面によって、APP_CO9908かAPP_CO9909のどちらかを実行
        if (this.$store.state.currentDisplayType === 1) {
          this.APP_CO9908();
        } else if (this.$store.state.currentDisplayType === 2) {
          this.APP_CO9909();
        }
      }
    },
  },
  beforMount() {
    this.$_setLoading(true);
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 遷移元からtabIndexのパラメータを受け取った場合にタブを切り替える
    // if (this.$route.params.tabIndex) {
    //   this.currentTab = this.$route.params.tabIndex;
    // }

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    if (this.$store.state.firstAidInfoId >= 0 && this.$store.state.firstAidInfoId <= 2) {
      this.personId = Number(this.$store.state.firstAidInfoId);
    } else {
      this.$router.push('/emergencyContact');
      return;
    }

    let param =
      this.$store.state.currentDisplayType === 1
        ? '/api/emergencyContactFirstAidInfo/getContactInfoForDisplayDistrict'
        : '/api/emergencyContactFirstAidInfo/getContactInfoForCamera';
    // let param = "post";

    let method = 'post';

    // 遷移元のパラメータによって対象地区とカメラのどちらかのAPIを実行
    if (this.$store.state.currentDisplayType === 1) {
      // APP_CU4401
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
      };
      await this.APP_CU4401(param, queries, method);
    } else if (this.$store.state.currentDisplayType === 2) {
      // APP_CU4402
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID,
      };
      await this.APP_CU4402(param, queries, method);
    }
  },
};
